import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { USAGE_TYPE_LABELS, getUsageTypeColor } from '@/routes/usage/constants'

const PLACEHOLDER_ROWS = Object.entries(USAGE_TYPE_LABELS).map(
  ([type, label]) => ({ type, label })
)

export const EmptyUsageTable = () => {
  return (
    <div>
      <div className="rounded-md border mx-6">
        <Table className="table-fixed">
          <TableHeader>
            <TableRow className="bg-muted/50 hover:bg-muted/50">
              <TableHead className="w-[50%] pl-4">Name</TableHead>
              <TableHead className="w-[18%] text-right">Net</TableHead>
              <TableHead className="w-[18%] text-right">Gross</TableHead>
              <TableHead className="w-[14%] text-right pr-4">
                % of total
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {PLACEHOLDER_ROWS.map(({ type, label }) => (
              <TableRow key={type}>
                <TableCell className="py-2 pl-4">
                  <div className="flex items-center gap-2 font-medium text-muted-foreground">
                    <div
                      className="size-2.5 rounded-full shrink-0 opacity-40"
                      style={{
                        backgroundColor: getUsageTypeColor(type),
                      }}
                    />
                    {label}
                  </div>
                </TableCell>
                <TableCell className="py-2 text-right tabular-nums text-muted-foreground">
                  N/A
                </TableCell>
                <TableCell className="py-2 text-right tabular-nums text-muted-foreground">
                  N/A
                </TableCell>
                <TableCell className="py-2 text-right text-muted-foreground tabular-nums pr-4">
                  N/A
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell className="font-medium pl-4 text-muted-foreground">
                Total
              </TableCell>
              <TableCell className="text-right font-medium tabular-nums text-muted-foreground">
                N/A
              </TableCell>
              <TableCell className="text-right font-medium tabular-nums text-muted-foreground">
                N/A
              </TableCell>
              <TableCell className="text-right text-muted-foreground tabular-nums pr-4">
                N/A
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </div>
  )
}
